import Instance from '../../../../Axios';

// New Actions for the app

const GetObrasUnidMedidas = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/all/unidMedidas`)
    .then(({ data }) => {
      dispatch({ type: 'GET_OBRAS_UNID_MEDIDAS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasUnidMedidas;
